import clsMerge from "@/app/util/clsMerge";
import Link from "next/link";
import {
	FocusEventHandler,
	ForwardedRef,
	MouseEventHandler,
	forwardRef,
} from "react";

export interface MultiSiteItemProps {
	id?: string;
	href: string;
	icon?: React.ReactNode;
	text: string;
	isCurrentPage?: boolean;
	shouldAlwaysShowText?: boolean;
	onMouseEnter?: MouseEventHandler<HTMLDivElement>;
	onMouseLeave?: MouseEventHandler<HTMLDivElement>;
	onFocus?: FocusEventHandler<HTMLAnchorElement>;
	onBlur?: FocusEventHandler<HTMLAnchorElement>;
}

const MultiSiteItem = (
	props: MultiSiteItemProps,
	ref: ForwardedRef<HTMLAnchorElement>
) => {
	const {
		id,
		href,
		icon,
		text,
		isCurrentPage,
		shouldAlwaysShowText = false,
	} = props;
	return (
		<Link
			id={id}
			className={clsMerge(
				"group-hover:shadow-[0_2px_6px_rgba(0,0,0,0.15)]xs:px-4 flex items-center gap-2 px-2 py-2 text-sm transition-colors duration-200 ease-in-out hover:bg-corporate-gray-100 hover:shadow-[0_2px_6px_rgba(0,0,0,0.15)] group-hover:bg-corporate-gray-100",
				isCurrentPage && "bg-corporate-gray-200"
			)}
			href={href}
			ref={ref}
		>
			{icon}
			<span className={shouldAlwaysShowText ? "" : "hidden md:flex"}>
				{text}
			</span>
		</Link>
	);
};

export default forwardRef<HTMLAnchorElement, MultiSiteItemProps>(MultiSiteItem);
